import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

const ErrorFallback = ({ error, resetErrorBoundary }) => (
  <div className="alerts-container">
    <div role="alert" className='text-center'>
      <p >Something went wrong.You will be redirected to login page </p>
      <button className='see-link ' onClick={resetErrorBoundary}>Try again</button>
    </div>
  </div>

);

const ErrorBoundary = ({ children, persistor }) => {

  // This function will run on error caught
  const handleError = async (error, info) => {
    console.error("Caught error in ErrorBoundary:", error, info);

    // Purge persisted Redux store
    if (persistor?.purge) {
      await persistor.purge();
      await persistor.flush?.();
    }

    // Clear storage
    sessionStorage.clear();
    localStorage.clear();

    // Redirect after cleanup
    setTimeout(() => {
      window.location.replace('/');
    }, 1000);
  };

  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={handleError}
      onReset={() => {
        // logic to reset state on "Try again"
        setTimeout(() => {
          window.location.replace('/');
        }, 1000);
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
